import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
})
export class MapComponent {
  @Input() lat = 0;
  @Input() lng = 0;
  @Input() zoom = 14;
  @Input() disabled = false;
  @Input() showMap = true;
  @Input() showMarker = true;

  constructor(private sanitizer: DomSanitizer) {}

  get mapsUrl(): SafeResourceUrl {
    const url = `https://www.google.com/maps?q=${this.lat},${this.lng}&z=${this.zoom}&output=embed`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
